const linkContextTypes = {
  UPDATE_FILE_LIST: 'UPDATE_FILE_LIST',
  UPDATE_ABHA_FORM_DATA: 'UPDATE_ABHA_FORM_DATA',
  GET_AUTH_MODES: 'GET_AUTH_MODES',
  SET_AUTH_MODES: 'SET_AUTH_MODES',
  GENERATE_OTP: 'GENERATE_OTP',
  VERIFY_OTP: 'VERIFY_OTP',
  SAVE_DOCUMENTS: 'SAVE_DOCUMENTS',
  RESET_LINK_RECORDS: 'RESET_LINK_RECORDS',
  SAVE_DOCS_WITHOUT_ABHA: 'SAVE_DOCS_WITHOUT_ABHA',
  FETCH_LINKED_RECORDS: 'FETCH_LINKED_RECORDS',
  RELOAD_LINKED_RECORDS_LIST: 'RELOAD_LINKED_RECORDS_LIST',
  APPLY_LINKED_RECORDS_FILTER: 'APPLY_LINKED_RECORDS_FILTER',
  UPDATE_LINKED_RECORD: 'UPDATE_LINKED_RECORD',
  GET_CLAIM_DOCS_FOR_ABHA: 'GET_CLAIM_DOCS_FOR_ABHA',
  SET_DOC_LIST_FOR_ABHA: 'SET_DOC_LIST_FOR_ABHA',
  GET_CLAIM_HEALTH_RECORDS: 'GET_CLAIM_HEALTH_RECORDS',
  SET_AUTH_FETCH_MODES_ERROR: 'SET_AUTH_FETCH_MODES_ERROR',
};
export default linkContextTypes;
